<template>
  <div class="option">
    <div class="option-info">
      <div class="option-name">{{ $t(`bet-slip.${option.name}`) }} {{ option.nameV }}</div>
      <div class="option-maximum-button" v-if="option.type !== 'singles'" @click="setMaximum">{{ $t('account.payments.deposit.max') + ': ' + (option.maximumSystemExpress).toFixed(2) + ' ' + currency }}</div>
    </div>
    <bet-slip-value class="option-value" v-if="option.type === 'accumulator'" :value="option.value.toFixed(2)" />
    <bet-slip-amount
      class="option-amount"
      :type="option.type === 'singles' ? 'SINGLES' : 'OPTION'"
      :target="option.code"
      :invalid="option.invalid"
      :amount="option.amount"
      :key="this.maximum" />
  </div>
</template>

<script>
import BetSlipAmount from '@/components/bet-slip/BetSlipAmount'
import BetSlipValue from '@/components/bet-slip/BetSlipValue'
import { mapState } from 'vuex'

export default {
  components: { BetSlipAmount, BetSlipValue },
  computed: {
    ...mapState({
      currency: state => state.user.currency
    })
  },
  data () {
    return {
      maximum: null
    }
  },
  props: {
    option: Object
  },
  methods: {
    setMaximum () {
      this.maximum = (this.option.maximumSystemExpress).toFixed(2)
    }
  }
}
</script>

<style scoped>
.option { display: flex; padding: 10px; }
.option:not(:last-child) { border-bottom: 1px solid rgba(255, 255, 255, .07); }
.option-info { flex: 1 1; margin: -2px 0; }
.option-maximum-button { cursor: pointer; }
.option-maximum-button:hover { color: #8c9eff; }
.option-value { float: right; margin: 5px 10px; }
.option-amount { display: flex; flex-direction: row-reverse; width: 102px; }
</style>



// WEBPACK FOOTER //
// src/components/bet-slip/BetSlipOption.vue